import React from 'react';
import CurrencyFormat from 'react-currency-format';
import PropTypes from 'prop-types';

export const priceFormat = (price, variant) => {
	switch (variant) {
		case 'diff':
			return {
          value: Math.abs(price),
          suffix: ',-',
          prefix: `€`
      };
		case 'zero':
			return {
          value: '0.00',
          suffix: '',
          thousandSeparator: ',',
          decimalSeparator: '.',
      };
		default:
			return {
          value: price,
          suffix: ',-',
          prefix: '€'
      };
	}
};

export default function ProductPrice(props) {
	return <CurrencyFormat
		displayType={'text'}
		thousandSeparator={'.'}
		decimalSeparator={','}
		prefix={'€'}
		suffix={',-'}
		{...props}
	/>
}

export const ProductPricePropTypes = PropTypes.shape({
	value: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]).isRequired,
	suffix: PropTypes.string,
	prefix: PropTypes.string,
	thousandSeparator: PropTypes.string,
	decimalSeparator: PropTypes.string,
});

ProductPrice.propTypes = ProductPricePropTypes.isRequired;